const customizeTemplateInfo = {
  title: 'How to Customize <br>Any Template',
  description:
    "You don't need to be a designer to create <br> good-looking videos for your marketing campaigns. Learn how to customize video templates to come up with wow-worthy videos!",
  videoId: '5fe0c86546e0fb000156959f'
};

export default customizeTemplateInfo;
